import React, { useEffect, useState } from 'react';

/**
 * @param productSku - The SKU of the product variant to display the TrustBox for.
 * @returns A React component that displays a TrustBox for a product.
 *
 * Documentation on the TrustBox widget: https://support.trustpilot.com/hc/en-us/articles/115011421468--Add-a-TrustBox-widget-to-a-single-page-application
 */
const TrustBox = ({ productSku }: { productSku: string }) => {
  // Add state to track if we're on client-side
  const [isMounted, setIsMounted] = useState(false);
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null);

  useEffect(() => {
    setIsMounted(true);
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    // @ts-ignore
    if (window.Trustpilot) {
      // @ts-ignore
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref} // We need a reference to this element to load the TrustBox in the effect.
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="544a426205dc0a09088833c6"
      data-businessunit-id="5b65a26a4a7a1a00011daaa0"
      data-style-height="500px"
      data-style-width="100%"
      data-sku={productSku}
      data-review-languages="en"
      data-no-reviews="show"
      data-fullwidth="true"
    />
  );
};
export default TrustBox;
